import { memo } from 'react';

import { Button } from '@/components/design-system/Button';
import { cn } from '@/utils/cn';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

interface HideMenuButtonProps {
  isNavCollapsed: boolean;
  toggleNavCollapse: () => void;
}

export const HideMenuButton = memo<HideMenuButtonProps>(({ isNavCollapsed, toggleNavCollapse }) => {
  return (
    <div className="sticky top-0 z-10">
      <Button
        onClick={toggleNavCollapse}
        variant="ghost"
        className={cn(
          'bg-background-300 text-typography/85 h-10 w-full transition-all duration-100 focus:outline-none',
          isNavCollapsed ? 'justify-center px-7' : 'justify-start gap-2.5 pr-5 pl-7'
        )}
        aria-label={isNavCollapsed ? 'Expand menu' : 'Collapse menu'}
      >
        {isNavCollapsed ? (
          <MenuUnfoldOutlined className="size-4" />
        ) : (
          <>
            <MenuFoldOutlined className="size-4" />
            <span className="text-sm">Hide Menu</span>
          </>
        )}
      </Button>
    </div>
  );
});
